'use strict';

import $ from 'jquery';

import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';
import 'bootstrap/js/src/tab';

import 'owl.carousel';

import 'whatwg-fetch';
import 'lazysizes';

// import cookie form 'cookie';
import objectFitImages from 'object-fit-images';
import cookieConsent from '@/Shared/cookieconsent';
import header from '@/Shared/header';
import serviceMessage from '@/Shared/service-message';
import bsHistory from '@/Shared/bootstrap/history';

// Modules
import hero from '@/Shared/modules/hero';
import video from '@/Shared/modules/video';
import tabSideNav from '@/Shared/modules/tab-sidenav';
import quiz from '@/Shared/modules/quiz';
import dynamicContentModal from '@/Shared/modules/modal/dynamic-content-modal';
import newsletter from '@/Shared/modules/newsletter';


// Add an alias to the App, if we need to call App from the outside:
window.App = window.App || {};

window.App.common = {
    // App.common.init runs on all pages
    init() {
        cookieConsent.init('#cookieContent');
        header.search.init('.js-toggle-search', '#search-container');
        header.navigation.init();
        hero.init();
        video.init();
        tabSideNav.init();
        bsHistory.init();
        dynamicContentModal.init();
        serviceMessage.init();
        newsletter.init();
        quiz.init({
            callback: {
                next: ($form) => {
                    if ($form.find('.js-lightbox-video')) {
                        import ( /* webpackChunkName: "lightbox" */ '@/Shared/lightbox')
                            .then(({ default: ligthbox }) => {
                                ligthbox.video('.js-lightbox-video');
                            });
                    }
                }
            }
        });

        this.objectFitFix();
        this.dynamicImportModules();
    },
    objectFitFix() {
        const $image2Fix = $('.js-object-fit-fill');

        if ($image2Fix.length) {
            objectFitImages($image2Fix);
        }
    },
    dynamicImportModules() {
        import ( /* webpackChunkName: "focusOnKeyboard" */ '@/Shared/helpers/helper.focusOnKeyboard').then(({ default: focusOnKeyboard }) => {
            focusOnKeyboard.init();
        });

        const tilesElm = document.querySelectorAll('.js-c-tiles');
        if (tilesElm) {
            import ( /* webpackChunkName: "tiles" */ '@/Shared/modules/tiles').then(({ default: tiles }) => {
                $(tilesElm).each(function() {
                    tiles.init(this);
                });
            });
        }

        const careerElm = document.querySelector('.js-career-module');
        if (careerElm) {
            import ( /* webpackChunkName: "career" */ '@/Shared/modules/career').then(({ default: career }) => {
                career.init(careerElm);
            });
        }

        const timelineListElm = document.querySelectorAll('.js-timeline-toggle');
        if (timelineListElm) {
            import ( /* webpackChunkName: "timelineList" */ '@/Shared/modules/timelinelist').then(({ default: timelineList }) => {
                timelineList.init(timelineListElm);
            });
        }

        const tableElm = $('.js-table');
        if (tableElm.length) {
            import ( /* webpackChunkName: "table" */ '@/Shared/modules/table').then(({ default: table }) => {
                table.init(tableElm);
            });
        }

        const tableFilterElm = $('.js-table-filter');
        if (tableFilterElm.length) {
            import ( /* webpackChunkName: "tableFilter" */ '@/Shared/modules/table/filter').then(({ default: tableFilter }) => {
                tableFilter.init(tableFilterElm);
            });
        }

        const lightBoxElm = document.querySelector('[class*=js-lightbox]');
        if (lightBoxElm) {
            import ( /* webpackChunkName: "lightbox" */ '@/Shared/lightbox').then(({ default: lightBox }) => {
                lightBox.normal('.js-lightbox');
                lightBox.iframe('.js-lightbox-iframe');
                lightBox.video('.js-lightbox-video');
            });
        }

        const autoOpenModal = $('.js-modal');
        if (autoOpenModal.length) {
            import ( /* webpackChunkName: "autoOpenModal" */ '@/Shared/modules/modal/auto-open-modal').then(({ default: modal }) => {
                modal.init({});
            });
        }

        const videoplayerModal = document.querySelector('.js-video-page');
        if (videoplayerModal) {
            import ( /* webpackChunkName: "videoplayer" */ '@/Shared/modules/videoplayer').then(({ default: videoplayer }) => {
                videoplayer.init({});
            });
        }
    }
};

/**
 * Initial Application bootstrapping
 */

// jQuery document ready
$(() => {
    window.App.common.init($);
});
